export default class NewDeviceStatusController {
	/**
	* To hide unresolved var in template
	* @typedef {object} wizardForm
  	*/

	static get $inject(){
		return [
			'$scope', '$state', '$stateParams', 'panel',
			'DeviceService',
			'$interval'
		];
	}

	constructor($scope, $state, $stateParams, panel,
                DeviceService, $interval){

		this.panelId = panel.control_panel.id;
		this.$state = $state;
		this.service = DeviceService;
		this.$interval = $interval;
		this.refresh();
		let interval = $interval(this.refresh.bind(this), 20000);
		$scope.$on('$destroy', () => {
			$interval.cancel(interval);
        });
	}

	refresh() {
		this.isLoading = true;
		this.service.getDevicesStatus(this.panelId)
			.then(data => {
				this.statusList = data;
				this.isLoading = false;
            })
	}

    cleanStatuses() {
	    this.isLoading = true;
	    this.service.cleanDevicesStatus(this.panelId)
            .then(this.refresh.bind(this));
    }
}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/new_devices_status/controller.js
 **/